import {Asset, Folder} from '../Assets.types';

/**
 * Finds an asset in the asset tree by ID
 * @param tree - The asset folder tree to search
 * @param assetId - The asset ID to find
 * @returns The asset if found, null otherwise
 */
export default function findAssetById(tree: Folder | null, assetId: number): Asset | null {
  if (!tree) {
    return null;
  }

  // Check assets in current folder
  if (tree.assets) {
    const found = tree.assets.find((asset) => asset.id === assetId);

    if (found) {
      return found;
    }
  }

  // Recursively search subfolders
  if (tree.folders) {
    for (const subfolder of tree.folders) {
      const found = findAssetById(subfolder, assetId);

      if (found) {
        return found;
      }
    }
  }

  return null;
}

